module.exports = __webpack_public_path__ + "static/media/img_logo_pc.94e7deb8.png";